export default __webpack_public_path__ + "static/media/simulate-ice-icon.a5990fc8.png";